// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m9q6C","content":"styles_content__3Gpwa","tableWrap":"styles_tableWrap__3OBZ0"};